import React, { useState, useEffect } from 'react';
import { TailSpin } from "react-loader-spinner";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../actions/auth';
import { Form, TextInput, Button  } from "@wfp/ui";
import { startLoading, finishLoading } from '../../actions/ui';
import { UpdateUser } from '../../controllers/UpdateUser';
import { NavBarHome } from '../../components/ui/NavBarHome';
import { GetUserData } from "../../controllers/GetUserData";
import transEs from '../../translate/es.json';
import transCat from '../../translate/cat.json';
import transDe from '../../translate/de.json';
import transEn from '../../translate/en.json';
import transFr from '../../translate/fr.json';
import transOt from '../../translate/ot.json';
import transPr from '../../translate/pr.json';
import { ConfigApp } from "../../controllers/ConfigApp";
import Select from 'react-select';


export const AccountScreen = () => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const { loading } = useSelector( state => state.ui );
    const langTxt = localStorage.getItem('userLanguage') || 'es';
    let transTxt = transEs;
    if(langTxt === 'es'){
        transTxt = transEs;
    }
    else if(langTxt === 'cat'){
        transTxt = transCat;
    }
    else if(langTxt === 'de'){
        transTxt = transDe;
    }
    else if(langTxt === 'en'){
        transTxt = transEn;
    }
    else if(langTxt === 'fr'){
        transTxt = transFr;
    }
    else if(langTxt === 'pr'){
        transTxt = transPr;
    }
    else{
        transTxt = transOt;
    }

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [idioma, setIdioma] = useState("");
    const [userChoice, setUserChoice] = useState('');
    const [options, setOptions] = useState([]);
    let user = useSelector( state => state.auth );
    const token = useSelector((state) => state.ui.token);
    if(!user?.id){
        if(sessionStorage.getItem('userSelect') && token){
            user = JSON.parse(sessionStorage.getItem('userSelect'));
        }
        else{
            dispatch(logout(token));
            history( '/auth/', {
            replace: true
            });
        }
    }
    let listUnit = [];
    let inLoop = false;
    useEffect(() => {
        if(!inLoop){
            inLoop = true;
            GetUserData(token)
            .then((e)=>{
                if(e.status === "Token is Expired"){
                    dispatch(logout(token));
                }
                // console.log(e)
                setName(e.name)
                setEmail(e.email)
                setIdioma(e.language_id)
            })
            .catch((e)=>{
                console.error(e);
                // dispatch(logout(token));
            });
            ConfigApp("/languages").then((e)=>{
                if(options.length===0){
                    e.forEach(a => {
                        setOptions( oldArray => [...oldArray, { value: a.id, label: a.name }])
                    })
                }
            })
            .catch((e)=>{
                console.warn(e);
                document.getElementById('invalidMessage').classList.remove('hide');
            });
        }
        
    }, [])

    useEffect(() => {
        document.getElementById('userName-error-msg').style.display="none";
        document.getElementById('userEmail-error-msg').style.display="none";
        document.getElementById('userPassword-error-msg').style.display="none";
        document.getElementById('userConfPassword-error-msg').style.display="none";
    }, [])
    let ingId = false
    useEffect(()=>{
        if(!ingId){
            ingId = true
            options.map(a => {
                    if(a.value===idioma){
                        setUserChoice( a ) 
                        // console.log('id',a)
                    }
                }
                )
        }
    },[options,idioma]
    )
    const handleSubmit = (e) => {
        e.preventDefault();
        const btnIngreso = document.getElementById("btnIngresar");
        btnIngreso.classList.remove("btn-wfp-main");
        btnIngreso.classList.add("btn-wfp-main-press");
        let userNameMain = document.getElementById('userName');
        let userName = userNameMain.value;
        let userEmailMain = document.getElementById('userEmail');
        let userEmail = userEmailMain.value;
        let userPasswordMain = document.getElementById('userPassword');
        let userPassword = userPasswordMain.value;
        let userConfPasswordMain = document.getElementById('userConfPassword');
        let userConfPassword = userConfPasswordMain.value;
        if(userName===""){
            userNameMain.classList.add("is-invalid");
            document.getElementById('userName-error-msg').style.display="block";
        }
        else{
            userNameMain.classList.remove("is-invalid");
            document.getElementById('userName-error-msg').style.display="none";
        }
        if(userEmail===""){
            userEmailMain.classList.add("is-invalid");
            document.getElementById('userEmail-error-msg').style.display="block";
        }
        else{
            document.getElementById('userEmail-error-msg').style.display="none";
        }
        if(userChoice===''){
            alert('Escoja el idioma')
        }
        let invalidMessage = document.getElementById('invalidMessage');
        if(userPassword.length < 6 && userPassword !== ''){
            alert(`${transTxt.registro.top.txt_3}`)
            invalidMessage.classList.add("invalid-tooltip-active");
        }
        else{
            
            if(userPassword === userConfPassword && userChoice!==''){
                dispatch( startLoading() );
                let dataLog = UpdateUser(token,userName,userEmail,userPassword,user.id,userChoice.value);
                dataLog.then((e)=>{
                    // console.log(e);
                    dispatch( finishLoading() );
                    let lang = 'es';
                    let userChoiceVal = parseInt(userChoice.value)
                    if(userChoiceVal===1){
                        lang = 'es';
                    }
                    else if(userChoiceVal===2){
                        lang = 'en';
                    }
                    else if(userChoiceVal===3){
                        lang = 'pr';
                    }
                    else if(userChoiceVal===4){
                        lang = 'fr';
                    }
                    else if(userChoiceVal===5){
                        lang = 'cat';
                    }
                    else if(userChoiceVal===6){
                        lang = 'de';
                    }
                    else{
                        lang = 'ot';
                    }
                    alert('Informacion actualizada correctamente.')
                    if(localStorage.getItem('userLanguage') !== lang){
                        localStorage.setItem('userLanguage',lang)
                        dispatch( logout(token) );
                    }
                    
                    
                })
                .catch((e)=>{
                    console.warn(e);
                    dispatch( finishLoading() );
                });
                invalidMessage.classList.remove("invalid-tooltip-active");
            }
            else{
                invalidMessage.classList.add("invalid-tooltip-active");
            }
        }
        
    }


    const disCourse = ()=>{
        
        return(
            <div className="text-account-main">
                <div className="invalid-feedback-c">
                    <strong id="invalidMessage" className="invalid-feedback">
                        * Contraseña y confirmacion de Contraseña deben ser iguales
                    </strong>
                </div>
                <Form onSubmit={ handleSubmit } className="needs-validation">
                    

                    <TextInput
                        placeholder={transTxt.registro.placeholder.imp_1}
                        className="form-control txt-input"
                        name="userName"
                        id="userName"
                        autoComplete="off"
                        invalid={{
                            message: ''
                            }}
                        invalidText={transTxt.registro.inv_msg.imp_1}
                        defaultValue={name}
                        required
                    />

                    <TextInput
                        placeholder={transTxt.registro.placeholder.imp_2}
                        className="form-control txt-input"
                        name="userEmail"
                        id="userEmail"
                        autoComplete="off"
                        invalid={{
                            message: ''
                            }}
                        invalidText={transTxt.registro.inv_msg.imp_2}
                        defaultValue={email}
                        required
                    />

                    <TextInput
                        type="password"
                        placeholder={transTxt.registro.placeholder.imp_3}
                        className="form-control txt-input"
                        id="userPassword"
                        name="userPassword"
                        autoComplete="off"
                        invalid={{
                            message: ''
                            }}
                        invalidText={transTxt.registro.inv_msg.imp_3}
                        required
                    />

                    <TextInput
                        type="password"
                        placeholder={transTxt.registro.placeholder.imp_4}
                        className="form-control txt-input"
                        id="userConfPassword"
                        name="userConfPassword"
                        autoComplete="off"
                        invalid={{
                            message: ''
                            }}
                        invalidText={transTxt.registro.inv_msg.imp_4}
                        required
                    />

                    <div id="idmacc" className="idm-act-cls"><span>{userChoice.label}</span></div>

                    {
                    
                        options && <Select id="slcLang" options={options} 
                        placeholder="Idioma"
                        classNames={{
                            control: (state) =>
                              'border-red-select',
                          }}

                         defaultValue = {
                            options.filter(option => 
                                option.value === idioma)
                         }
                        onChange={(choice) => setUserChoice(choice)}
                        styles={{
                            color: 'red',
                          }}/>
                    }

                    <Button
                        id="btnIngresar"
                        type="submit"
                        className="btn m-1 btn-block btn-outline-primary btn-wfp-main btn-up-data"
                        disabled={ loading }
                    >
                        {transTxt.btn.actualizar.txt}
                    </Button>
                </Form>
            </div>
        );
    }
    return (
        <div className="fund-main-enter">
            <NavBarHome />


                <div className="content-questions" >
 
                {!listUnit && <div className="loader-page"><TailSpin
                    color="#00BFFF"
                    height={200}
                    width={200}
                />
                </div>}
                    { options && disCourse() }
                </div>
                

        </div>
    )
}
